module.exports = __webpack_public_path__ + "static/media/rim-back-left.79ba0f13.jpg";